import React from "react";
import Closebtn from "icons/Closebtn";
interface PaymentFailedInterface {
  setPaymentFailed: Function;
}
export const Paymentfailed: React.FC<PaymentFailedInterface> = ({
  setPaymentFailed,
}) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-black/70 backdrop-blur-md z-999 px-5 flex items-center justify-center">
        <div className="bg-white max-w-full md:max-w-458px min-w-458px px-8 py-8  rounded-xl z-50 text-center space-y-3 relative">
          <div
            onClick={() => {
              setPaymentFailed(false);
            }}
            className="bg-RedT/20 border-RedT border w-20 h-20 rounded-full flex items-center justify-center mx-auto"
          >
            <Closebtn className="fill-black" />
          </div>
          <div className="max-w-80 space-y-3 mx-auto">
            <h5 className="text-2xl font-semibold text-black">
              Payment Failed
            </h5>
            <p className="text-sm font-normal text-darkgray">
              Unfortunately we have an issue with your payment, try again later.
            </p>
          </div>
          <div
            className="flex items-center justify-center gap-4 !mt-5"
            onClick={() => {
              setPaymentFailed(false);
            }}
          >
            <button className="text-base  w-full text-black rounded-full bg-white font-bold border border-Cetaceanblue/20 transition-all duration-300 ease-in-out hover:bg-Cetaceanblue hover:text-white px-8 py-2.5">
              Cancel
            </button>
            <button className="text-base font-bold w-full text-black rounded-full bg-skyblue transition-all ease-in-out duration-300 border hover:bg-white border-skyblue px-8 py-2.5">
              Try Again!
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
